module.exports = __webpack_public_path__ + "static/img/30019 (2).cefa72d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30019 (2).webp
// module id = DwaC
// module chunks = 14